export const experience = [
  {
    title: "Staff Software Engineer, Applied AI",
    company: "Invisible Technologies",
    location: "US Remote",
    dates: "May 2026 – Present",
    highlights: [
      "Forward-deployed with enterprise clients to design and ship production AI systems",
      "Build RAG pipelines and multi-agent workflows with Python, LLMs, and cloud infrastructure",
      "Partner with ML engineers to integrate advanced AI capabilities in dynamic production environments",
    ],
  },
  {
    title: "Senior Engineering Manager",
    company: "Mandolin",
    location: "US Remote",
    dates: "Oct 2025 – May 2026",
    highlights: [
      "Led multi-team effort to replace legacy Document Intake with a scalable architecture, reducing incidents by 30%+",
      "Spearheaded XDB + Temporal migration for durable, fault-tolerant data workflows",
      "Drove HIPAA and SOC2 readiness with enterprise security posture improvements",
    ],
  },
  {
    title: "Engineering Manager",
    company: "Happy Returns, a UPS company",
    location: "US Remote",
    dates: "Nov 2022 – Oct 2025",
    highlights: [
      "Led 0-to-1 zone skip infrastructure, improving shipment completion by 15% and reducing costs by 10%",
      "Championed trunk-based development, reducing lead time by 71% (7 to 2 days)",
      "Built billing platform with 99.9% uptime in partnership with Finance and Data teams",
    ],
  },
  {
    title: "Engineering Manager",
    company: "Lob",
    location: "San Francisco, CA",
    dates: "Jan 2019 – Jun 2022",
    highlights: [
      "Led 2 teams building a platform processing 10M+ daily requests across print, mail, and digital",
      "Modernized 7-year-old routing framework, reducing incident rate by 20%",
      "Designed automated partner onboarding platform enabling 75% faster integration cycles",
    ],
  },
  {
    title: "Software Engineer",
    company: "Kraken",
    location: "San Francisco, CA",
    dates: "Mar 2018 – Dec 2019",
    highlights: [
      "Built backend services in Go and real-time metrics dashboards",
      "Migrated critical workloads from MongoDB to PostgreSQL, improving availability by 20%",
      "Optimized CI/CD pipeline, reducing build times by 40%",
    ],
  },
  {
    title: "Financial Systems Analyst",
    company: "Quantcast",
    location: "San Francisco, CA",
    dates: "Aug 2016 – Oct 2017",
    highlights: [
      "Built real-time Tableau financial dashboard for executive team and investment partners",
      "Maintained 5-year long-range income and headcount model in Oracle Hyperion",
    ],
  },
  {
    title: "Network Engineer Consultant",
    company: "PricewaterhouseCoopers",
    location: "San Francisco, CA",
    dates: "Jun 2015 – Aug 2016",
    highlights: [
      "Managed firewall remediation across 160+ Cisco firewalls for a major airline",
      "Assessed network integrity for a government power plant to prevent cyber attacks",
    ],
  },
];
